document.addEventListener("contextmenu", (event) => event.preventDefault()); // Blokuje prawy przycisk myszy

document.addEventListener("keydown", (event) => {
    if (
        event.key === "F12" || // Blokada F12
        (event.ctrlKey && event.shiftKey && event.key === "I") || // Blokada Ctrl+Shift+I (DevTools)
        (event.ctrlKey && event.shiftKey && event.key === "J") || // Blokada Ctrl+Shift+J (Console)
        (event.ctrlKey && event.key === "U") // Blokada Ctrl+U (View Source)
    ) {
        event.preventDefault();
    }
});

// Wykrywanie DevTools poprzez sprawdzanie konsoli
(function() {
    const element = new Image();
    Object.defineProperty(element, 'id', {
        get: function() {
            alert("Wykryto próby podglądu kodu!"); // Możesz zamiast tego przekierować np. window.location.href = "https://google.com";
            window.location.href = "https://google.com";
        }
    });
    console.log('%c', element);
})();
